var _circle, _circle2, _path, _circle3, _circle4, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnedocpair(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.52 42.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 37.783,
    cy: 21.108,
    r: 1.445
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_main",
    cx: 11.016,
    cy: 8.26,
    r: 3.206
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M14.222 21.108h5.238"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_sub",
    cx: 11.016,
    cy: 21.108,
    r: 3.206
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_sub",
    cx: 11.016,
    cy: 33.915,
    r: 3.206
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M14.956 8.26h5.848a2.9 2.9 0 012.891 2.891v5.972"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M14.956 33.915h5.848a2.9 2.9 0 002.891-2.891v-5.247"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M32.433 21.108h-5.848a2.9 2.9 0 01-2.891-2.891v-5.972"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnedocpair);
export default __webpack_public_path__ + "static/media/onedocpair.36b0ab20003b8751a72d9bc1c18a5d0c.svg";
export { ForwardRef as ReactComponent };